module.exports = __webpack_public_path__ + "media/images/login-bonus-kv@3x-9c94ee7386ca9e3573509ae59cbdfbbd.png";